import { AideAudienceStubPage } from '../../../../components/aides/AideAudienceStubPage';
import { getAideIndustrieStub } from '../../../../config/aides-industrie';

export default function OptimisationTurpePage() {
  const aide = getAideIndustrieStub('optimisation-turpe');
  if (!aide) return null;
  return <AideAudienceStubPage aide={aide} audienceId="industrie" />;
}
